import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SESSION_FEATURE_KEY } from './session.reducer';
import { SessionState } from './session.state';

export const sessionState =
  createFeatureSelector<SessionState>(SESSION_FEATURE_KEY);

export const getSession = createSelector(
  sessionState,
  ({ session }) => session,
);

export const getSessionStartTimestamp = createSelector(
  sessionState,
  ({ sessionStartTimestamp }) => sessionStartTimestamp,
);

export const hasSession = createSelector(
  sessionState,
  (state) => {
    return !!state.sessionStartTimestamp;
  },
);

export const getWarningThreshold = createSelector(
  sessionState,
  ({ warningThreshold }) => warningThreshold,
);

export const getExpirationDate = createSelector(
  getSession,
  getSessionStartTimestamp,
  (session, sessionStartTimestamp) => {
    if (!session?.sessionTimeout || !sessionStartTimestamp) return undefined;
    return new Date(sessionStartTimestamp + session.sessionTimeout * 1000);
  },
);

export const getWarningDate = createSelector(
  getSession,
  getSessionStartTimestamp,
  getWarningThreshold,
  (session, sessionStartTimestamp, warningThreshold) => {
    if (!session?.sessionTimeout || !sessionStartTimestamp) return undefined;
    return new Date(
      sessionStartTimestamp +
        (session.sessionTimeout * 1000 - warningThreshold),
    );
  },
);

export const getToken = createSelector(
  getSession,
  (session) => session?.accessToken,
);
